import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function linkButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'linkButton',
    baseStyle: {
      position: 'relative',
      color: theme.colors.text,
      alignItems: 'center',
      display: 'inline-flex',

      '&:before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: -401,
        borderRadius: theme.sizes['-2']
      },

      '&:after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: -400,
        borderRadius: theme.sizes['-2']
      }
    },
    variants: {
      primary: {
        '&:before': {
          mixBlendMode: 'plus-lighter',
          background: `linear-gradient(
            0deg,
            rgba(67, 49, 233, 0.4) 0%,
            rgba(67, 49, 233, 0.4) 100%
          )`
        },
        '&:after': {
          mixBlendMode: 'soft-light',
          border: `solid 1px ${theme.colors.white25}`,
          background: `radial-gradient(
                116.48% 116.48% at 50% 2.27%,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.25) 100%
              ),
              rgba(255, 255, 255, 0.3);`
        },

        '&:hover': {
          color: theme.colors.text,
          '&:before': {
            background: `linear-gradient(
                0deg,
                rgba(67, 49, 233, 0.15) 0%,
                rgba(67, 49, 233, 0.15) 100%
              );`
          }
        }
      },
      secondary: {
        '&:before': {
          mixBlendMode: 'overlay',
          border: `solid 1px ${theme.colors.white}`
        },

        '&:hover': {
          color: theme.colors.text,

          '&:after': {
            mixBlendMode: 'overlay',
            background: theme.colors.white25
          }
        }
      },
      linkCard: {
        justifyContent: 'center',
        '&:before': {
          mixBlendMode: 'plus-lighter',
          background: `linear-gradient(
            0deg,
            rgba(67, 49, 233, 0.4) 0%,
            rgba(67, 49, 233, 0.4) 100%
          )`
        },
        '&:after': {
          mixBlendMode: 'soft-light',
          border: `solid 1px ${theme.colors.white25}`,
          background: `radial-gradient(
                116.48% 116.48% at 50% 2.27%,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.25) 100%
              ),
              rgba(255, 255, 255, 0.3);`
        },

        '&:hover': {
          color: theme.colors.text,
          '&:before': {
            background: `linear-gradient(
                0deg,
                rgba(67, 49, 233, 0.15) 0%,
                rgba(67, 49, 233, 0.15) 100%
              );`
          }
        }
      }
    },
    defaultProps: {
      variant: 'primary'
    }
  };
}
